/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';

// Components
import { notifications } from '@mantine/notifications';

// Types
import { IApiError, TUser } from '@global-types/index';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const remove = (id: string): Promise<TUser> => {
	return apiClient.delete(`/users/${id} `);
};

export const useRemove = (page: number, size: number) => {
	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: remove,
		onSuccess: () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'users.notifications.userSuccessfullyDeleted'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: ['users', { page: page, size: size }],
			});
		},
		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading };
};
